export default __webpack_public_path__ + "static/media/page-name-img.3eb47619.png";